import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

// API/Components
import axiosInstance from '../components/axios';
import SystemMeasurementSummary from '../components/analysis_system_summary';
import SystemStatsSummary from '../components/analysis_system_stats';
import StringsSummary from '../components/analysis_strings_summary';
import UnitStatsSummary from '../components/analysis_unit_stats';
import UnitAnalysisSummary from '../components/analysis_unit_summary';


// Material UI
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

// System Trend sub-page rendering (Location Name, Title)
export default function SystemAnalysis() {
	const { locationNum } = useParams();

	// State Management
	const [locationInfo, setLocationInfo] = useState({
		locationName: '',
		numStrings: 0,
		numUnits: 0,
		numTemps: 0,
	});

	// Analysis Data
	const [systemAnalysisData, setSystemAnalysisData] = useState({});
	const [stringAnalysisData, setStringAnalysisData] = useState([]);
	const [unitAnalysisData, setUnitAnalysisData] = useState({});

	// Loading States
	const [isSystemLoading, setIsSystemLoading] = useState(true);
	const [isStringLoading, setIsStringLoading] = useState(true);
	const [isUnitLoading, setIsUnitLoading] = useState(true);

	// Get information about the location id specified (name, size, num of temps)
	useEffect(() => {
		axiosInstance.get(`/loc/${locationNum}/size/`).then(response => {
			const locationInfo = response.data;
			setLocationInfo({
				locationName: locationInfo.location_name,
				serialNumber: locationInfo.serial_number,
				numStrings: locationInfo.num_strings,
				numUnits: locationInfo.num_units_per_string,
				numTemps: locationInfo.num_temps,
			});
		});
	}, [locationNum]);
	
	// Get the list of trend data for the specified location id, string number, and unit number
	useEffect(() => {
		// Get System Analysis Data
		axiosInstance.get(`/loc/${locationNum}/analysis`)
			.then(response => {
				setSystemAnalysisData(response.data);
			})
			.finally(() => {
				setIsSystemLoading(false);
			});

		// Get String Analysis Data
		axiosInstance.get(`/loc/${locationNum}/analysis/strings`)
			.then(response => {
				setStringAnalysisData(response.data);
			})
			.finally(() => {
				setIsStringLoading(false);
			});


		// Get Unit Analysis Data
		axiosInstance.get(`/loc/${locationNum}/analysis/units`)
			.then(response => {
				setUnitAnalysisData(response.data);
			})
			.finally(() => {
				setIsUnitLoading(false);
			});
	}, [locationNum]);

	return (
		<Paper
			padding='true'
			sx={{
				overflow: 'auto',
				boxShadow: '0',
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<Typography
				variant='h5'
				fontFamily='Saira, sans-serif'
				fontWeight='600'
				color='#0F1820'
				align='center'
				padding='5px'
			>
				{ locationInfo.locationName } (SN {locationInfo.serialNumber})
			</Typography>
			<Toolbar>
				<Grid container spacing={1} alignItems="center">
					<Grid item xs alignItems="left">
						<Typography
							align="left"
							fontFamily='Saira,sans-serif'
							fontWeight='600'
							sx={{ flexGrow: 1}}
						>
							System Analysis
						</Typography>
					</Grid>
				</Grid>
			</Toolbar>
			<Grid container spacing={2}>
				<Grid item xs={12} md={6}>
					<SystemMeasurementSummary systemAnalysisData={systemAnalysisData} loading={isSystemLoading} />
				</Grid>
				<Grid item xs={12} md={6}>
					<SystemStatsSummary systemAnalysisData={systemAnalysisData} loading={isSystemLoading} />
				</Grid>
				<Grid item xs={12}>
					<StringsSummary stringAnalysisData={stringAnalysisData} loading={isStringLoading} />
				</Grid>
				<Grid item xs={12}>
					<UnitStatsSummary unitAnalysisData={unitAnalysisData} loading={isUnitLoading} />
				</Grid>
				<Grid item xs={12}>
					<UnitAnalysisSummary unitAnalysisData={unitAnalysisData} loading={isUnitLoading} />
				</Grid>
			</Grid>
		</Paper>
	);
}